module.exports = __webpack_public_path__ + "img/f145cdd.jpeg";